module.exports = "<p>\r\n  hosteleria works!\r\n</p>\r\n"